import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getDefaultRoute } from '../utils/getDefaultRoute';
import { isProblemIntelligenceReadUiEnabled } from '../config/problemIntelligenceFlags';

/**
 * Blocks Problem Library route shell when the read UI flag is OFF (Story 5.1).
 * Matches nav visibility — no URL bypass.
 */
export function RequireProblemIntelligenceRead({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!isProblemIntelligenceReadUiEnabled()) {
    return <Navigate to={getDefaultRoute(user.role, user)} replace />;
  }
  return children;
}
